import React from 'react'
import BlockIconGrid from '@berlitz/blocks/lib/BlockIconGrid'
import { getBackgroundColor } from '../../functions/utils'
import { SliceWrapper } from '../SliceWrapper'

const SliceIconGrid = ({ primary, items, large_icons, light }) => {
  const darkBackgrounds = ['#004FEF', 'purple', '#1D1D1D']
  const hasDarkBackground = darkBackgrounds.includes(getBackgroundColor(primary.section_background_color))
  return (
    <SliceWrapper backgroundColor={getBackgroundColor(primary.section_background_color)} hasDarkBackground={hasDarkBackground}>
      <BlockIconGrid
        title={primary.title1}
        subtitle={primary.subtitle1.text}
        gridItems={items.map(item => ({
          title: item.icon_title,
          subtitle: item.icon_content,
          iconName: item.icon_name,
          link: item.icon_link.url,
        }))}
        largeIcons={large_icons}
        light={light}
        backgroundColor={getBackgroundColor(primary.section_background_color)}
      />
    </SliceWrapper>
  )
}

export default SliceIconGrid
